import React from 'react';
import styled from 'styled-components';

import Tooltip from 'rc-tooltip';
import 'app/style/tooltip.css';

import { Text, Heading as GrommetHeading } from 'grommet';
import Anchor from 'app/components/Anchor';

const contextPattern = /\$\{([^}]+)\}\{(tooltip|link|italic|supplement|header|heading|bold)(?:: )?([^}]*)\}/;

const ItalicText = styled(Text)`
  font-style: italic;
  font-size: inherit;
`;

const Heading = styled(GrommetHeading)`
  hyphens: none;
`;

const TooltipAnchor = styled(Text)`
  border-bottom: 1px dashed #000;
  :hover {
    cursor: pointer;
  }
`;

const Markup = {};

Markup.parse = contents => {
  const hasMarkup = contents.match(contextPattern);
  if (!hasMarkup) return contents;

  const [context, anchor, type, markup] = hasMarkup;
  const front = contents.substring(0, hasMarkup.index);
  const wrapper = {
    tooltip: (
      <Tooltip
        placement="top"
        trigger={['click']}
        overlay={<Text size="small">{markup}</Text>}
      >
        {
          <TooltipAnchor color="black" weight="bold">
            {anchor}
          </TooltipAnchor>
        }
      </Tooltip>
    ),
    link: (
      <Anchor href={markup} rel="noopener noreferrer" target="_blank">
        {anchor}
      </Anchor>
    ),
    italic: <ItalicText>{anchor}</ItalicText>,
    bold: <Text weight="bold">{anchor}</Text>,
    supplement: <ItalicText>[{anchor}]</ItalicText>,
    heading: (
      <Heading textAlign="center" size={markup || 'large'} margin="none">
        {anchor}
      </Heading>
    ),
    header: (
      <Text weight="bold" size={markup || 'large'}>
        {anchor}
      </Text>
    ),
  };
  const back = Markup.parse(
    contents.substring(hasMarkup.index + context.length)
  );
  return (
    <React.Fragment>
      {front}
      {wrapper[type]}
      {back}
    </React.Fragment>
  );
};

Markup.remove = contents => {
  const hasMarkup = contents.match(contextPattern);
  if (!hasMarkup) return contents;

  const [context, anchor] = hasMarkup;
  const front = contents.substring(0, hasMarkup.index);

  const back = Markup.remove(
    contents.substring(hasMarkup.index + context.length)
  );
  return front + anchor + back;
};

export default Markup;



// WEBPACK FOOTER //
// ./src/app/api/markup.js